import React from 'react';
import { motion } from 'framer-motion';

interface SoftCardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  onClick?: () => void;
}

const SoftCard: React.FC<SoftCardProps> = ({ 
  children, 
  className = '', 
  hover = true,
  onClick 
}) => {
  return (
    <motion.div
      className={`
        bg-white border border-gray-200 rounded-2xl shadow-sm
        transition-all duration-300 ease-in-out
        ${hover ? 'hover:shadow-lg hover:-translate-y-1' : ''}
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `}
      whileHover={hover ? { 
        scale: 1.02,
        boxShadow: '0 10px 25px rgba(168, 213, 186, 0.15)'
      } : {}}
      whileTap={onClick ? { scale: 0.98 } : {}}
      onClick={onClick}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {children}
    </motion.div>
  );
};

export default SoftCard;